import React from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { ThemeModeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ModalProvider } from "@/context/ModalContext";
import { SavedProvider } from "@/context/SavedContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

import Landing from "@/pages/Landing";
import Generator from "@/pages/Generator";
import Results from "@/pages/Results";
import Saved from "@/pages/Saved";
import HistoryPage from "@/pages/History";
import Pricing from "@/pages/Pricing";
import Profile from "@/pages/Profile";
import SeoLanding from "@/pages/SeoLanding";
import Bulk from "@/pages/Bulk";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AuthCallback from "@/pages/AuthCallback";
import NotFound from "@/pages/NotFound";

function Shell() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

const SEO_PAGES = [
  "business-name-generator",
  "brand-name-generator",
  "app-name-generator",
  "startup-name-generator",
  "company-name-generator",
  "domain-name-generator",
];

export default function App() {
  return (
    <ThemeModeProvider>
    <BrowserRouter>
      <AuthProvider>
        <ModalProvider>
          <SavedProvider>
            <Routes>
              <Route element={<Shell />}>
                <Route path="/" element={<Landing />} />
                <Route path="/generate" element={<Generator />} />
                <Route path="/results/:id" element={<Results />} />
                <Route path="/saved" element={<Saved />} />
                <Route path="/history" element={<HistoryPage />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/bulk" element={<Bulk />} />
                {SEO_PAGES.map((slug) => (
                  <Route key={slug} path={`/${slug}`} element={<SeoLanding slug={slug} />} />
                ))}
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
            </Routes>
            <Toaster position="top-center" richColors />
          </SavedProvider>
        </ModalProvider>
      </AuthProvider>
    </BrowserRouter>
    </ThemeModeProvider>
  );
}
